import styled from 'styled-components';

export const Container = styled.div`
  small {
    font-size: 12px;
  }
  .qty-size {
    width: 191px;
  }

  .border-danger {
    border: 1px solid #dc3545 !important;
  }
`;
